export default () => window.innerWidth < 1024
